import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { MicroFrontendResolver } from 'core/resolvers';
import { ReportResolver } from './resolvers/report.resolver';
import { ReportingToolComponent } from './reporting-tool/reporting-tool.component';
import { ReportsComponent } from './reports/reports.component';

const reportsRoutes: Routes = [
  {
    path: 'reports',
    title: 'parentReports',
    data: { microfrontends: ['GlReports'] },
    resolve: {
      glreports: MicroFrontendResolver
    },
    children: [
      {
        path: '',
        title: 'reports',
        component: ReportsComponent,
        canActivate: [ProfileGuard],
        resolve: { personalization: ReportResolver },
        data: { action: 'reports.menu' }
      },
      {
        path: 'licenses',
        title: 'reportLicenses',
        component: ReportingToolComponent,
        canActivate: [ProfileGuard],
        resolve: { personalization: ReportResolver },
        data: { action: 'reports.licenses', report: 'licenses' }
      },
      {
        path: 'groups',
        title: 'reportGroups',
        component: ReportingToolComponent,
        canActivate: [ProfileGuard],
        resolve: { personalization: ReportResolver },
        data: { action: 'reports.groups', report: 'groups' }
      },
      {
        path: 'students',
        title: 'reportStudents',
        component: ReportingToolComponent,
        canActivate: [ProfileGuard],
        resolve: { personalization: ReportResolver },
        data: { action: 'reports.students', report: 'students' }
      },
      {
        path: 'events',
        title: 'reportEvents',
        component: ReportingToolComponent,
        canActivate: [ProfileGuard],
        resolve: { personalization: ReportResolver },
        data: { action: 'reports.events', report: 'events' }
      },
      {
        path: 'activity',
        title: 'reportActivity',
        component: ReportingToolComponent,
        canActivate: [ProfileGuard],
        resolve: { personalization: ReportResolver },
        data: { action: 'reports.activity', report: 'activity' }
      },
      {
        path: 'surveys',
        title: 'reportSurveys',
        component: ReportingToolComponent,
        canActivate: [ProfileGuard],
        resolve: { personalization: ReportResolver },
        data: { action: 'reports.surveys', report: 'surveys' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(reportsRoutes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule {}
